module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "retirement-planner-wrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm._translate('retirementPlanner.title')))]), _vm._v(" "), _c('div', {
    staticClass: "report__client-info",
    domProps: {
      "innerHTML": _vm._s(_vm.showClientInfo())
    }
  }), _vm._v(" "), (_vm.setStoreTables()) ? _c('div', {
    staticClass: "report-content"
  }, [_c('div', {
    staticClass: "retirement__block"
  }, [_c('div', {
    staticClass: "report__disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.showDisclaimer())
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('outlook')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('outlook')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('outlook')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.outlookTitle')))])]), _vm._v(" "), (this.$data.blocks.outlook) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.yearsInRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(this.getRetirementDataPoint('outlook',
        'years'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.investmentAssetsAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(this.getRetirementDataPoint('outlook',
        'assets'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.targetValueOfEstate')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.getRetirementDataPoint('outlook',
        'estate')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.shortfallExcess')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getShortfallExcess()))
    }
  })]), _vm._v(" "), (_vm.getShortfallExcess() < 0) ? _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.requiredOneTimeInvestmentAt')) + " "), _c('TextInput', {
    attrs: {
      "id": "oneTimeRate",
      "field": "retirement.oneTimeRate",
      "type": "percentage"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getInvestmentRequired()))
    }
  })]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "report__list-item report__list-item--functional"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.distributeWealth')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.minimizeExcess('income')
      }
    }
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.byIncome')))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('income')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('income')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('income')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.retirementIncomeRequired')))])]), _vm._v(" "), (this.$data.blocks.income) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.presentAge')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getClientAge())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.presentYearlyIncome')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getBaseField('income.presentIncome')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.ageToRetire')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRetirmentAge())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.targetIncomeAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getProjectedFirstIncomePercentage()))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._prints(_vm._translate('retirementPlanner.incomeAtRetirement'), _vm.getInitialAge())))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getProjectedFirstIncome()))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.ageOfPassiveRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getBaseField('retirement.passiveRetirementAge'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.incomeRequiredInPassiveRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(Number(_vm.getBaseField('retirement.passiveIncomeRequired'))))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.projectedRateOfInflation')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getInflationRate())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.projectedRateOfReturn')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRateOfReturn())
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.estimatedLifeExpectancy')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getBaseField('retirement.lifeExpectancy'))
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('government')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('government')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('government')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.governmentBenefits')))])]), _vm._v(" "), (this.$data.blocks.government) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.currentMaximumCppPayout')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getMaxCPPPayout()))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._prints(_vm._translate('retirementPlanner.projectedEligibleCppAtAgeOf'), _vm.getBaseField('retirement.cppAtAge'))))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getCppPayout(_vm.getBaseField('retirement.cppAtAge'))))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.indexCppAt')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getBaseField('retirement.cppIndex')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.currentMaximumOasPayout')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getMaxOASPayout()))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._prints(_vm._translate('retirementPlanner.projectedOasAtTheAgeOf'), _vm.getBaseField('retirement.oasAtAge'))))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getOasPayout(_vm.getBaseField('retirement.oasAtAge'))))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.indexOasAt')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getBaseField('retirement.oasIndex')))
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('company')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('company')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('company')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.pensionTitle')))])]), _vm._v(" "), (this.$data.blocks.company) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.startReceivingPensionAtAge')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getBaseField('retirement.pensionAge'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.integrateWithCpp')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getYesNo('retirement.cppIntegrate'))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.indexPensionAt')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getBaseField('retirement.pensionIndex')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.projectedInitialBenefit')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getPensionPayout(_vm.getBaseField('retirement.pensionAge'))))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.pensionBridgeAmount')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getYesNo('retirement.hasBridgeBenefit'))
    }
  })]), _vm._v(" "), (_vm.getBaseField('retirement.hasBridgeBenefit') === 'true') ? _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.brdigeBenefitAmount')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getBaseField('retirement.bridgeValue') * 12))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getBaseField('retirement.hasBridgeBenefit') === 'true') ? _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.bridgeBenefitStarts')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getBaseField('retirement.bridgeStart'))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.getBaseField('retirement.hasBridgeBenefit') === 'true') ? _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.bridgeBenefitEnds')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.getBaseField('retirement.bridgeEnd'))
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('regularInvestments')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('regularInvestments')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('regularInvestments')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.savingsInvestmentTitle')))])]), _vm._v(" "), (this.$data.blocks.regularInvestments) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryCurrentValue')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingCurrentYearTotal('open')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalValueAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingFinalYearTotal('open')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalContributions')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAccountsContributions('open')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryRateOfReturn')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getAccountsReturnRate('open')))
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('tfsaInvestments')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('tfsaInvestments')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('tfsaInvestments')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.tfsaTitle')))])]), _vm._v(" "), (this.$data.blocks.tfsaInvestments) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryCurrentValue')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingCurrentYearTotal('tfsa')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalValueAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingFinalYearTotal('tfsa')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalContributions')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAccountsContributions('tfsa')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryRateOfReturn')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getAccountsReturnRate('tfsa')))
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('groupInvestments')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('groupInvestments')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('groupInvestments')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.registeredInvestmentsTitle')))])]), _vm._v(" "), (this.$data.blocks.groupInvestments) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryCurrentValue')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingCurrentYearTotal('rrsp_nodpsp')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalValueAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingFinalYearTotal('rrsp_nodpsp')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalContributions')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAccountsContributions('rrsp_nodpsp')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryRateOfReturn')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getAccountsReturnRate('rrsp_nodpsp')))
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('dpspInvestments')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('dpspInvestments')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('dpspInvestments')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.dpspTitle')))])]), _vm._v(" "), (this.$data.blocks.dpspInvestments) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryCurrentValue')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingCurrentYearTotal('dpsp')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalValueAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingFinalYearTotal('dpsp')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalContributions')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAccountsContributions('dpsp')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryRateOfReturn')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getAccountsReturnRate('dpsp')))
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.sectionClass('lockedinInvestments')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('lockedinInvestments')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('lockedinInvestments')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.lockedinInvetmentsTitle')))])]), _vm._v(" "), (this.$data.blocks.lockedinInvestments) ? _c('ul', {
    staticClass: "report__list"
  }, [_c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryCurrentValue')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingCurrentYearTotal('lockedin')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalValueAtRetirement')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAssetGroupingFinalYearTotal('lockedin')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryTotalContributions')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(_vm.getAccountsContributions('lockedin')))
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "report__list-item"
  }, [_c('span', {
    staticClass: "report__list-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.summaryRateOfReturn')))]), _vm._v(" "), _c('span', {
    staticClass: "report__value",
    domProps: {
      "innerHTML": _vm._s(_vm.formatPercentage(_vm.getAccountsReturnRate('lockedin')))
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.getWealthAccumulationData().length > 0) ? _c('div', {
    staticClass: "retirement__block"
  }, [_c('div', {
    class: _vm.sectionClass('wealthAccumulation')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('wealthAccumulation')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('wealthAccumulation')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.wealthAccumulation')))]), _vm._v(" "), (this.$data.blocks.wealthAccumulation) ? _c('span', {
    staticClass: "section__buttons"
  }, [_c('button', {
    class: _vm.buttonClass('wealthAccumulation', 'list'),
    on: {
      "click": function($event) {
        _vm.toggleView('wealthAccumulation', 'list')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "view-list"
    }
  })], 1), _vm._v(" "), _c('button', {
    class: _vm.buttonClass('wealthAccumulation', 'table'),
    on: {
      "click": function($event) {
        _vm.toggleView('wealthAccumulation', 'table')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "view-table"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (this.$data.blocks.wealthAccumulation && _vm.showWealthAccumulation()) ? _c('Chart', {
    attrs: {
      "type": "bar",
      "stacked": "true",
      "data": _vm.chartWealthAccumulation(),
      "id": "wealthAccumulationChart"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "report__disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.showDisclaimer())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "retirement__table-wrap"
  }, [(this.$data.blocks.wealthAccumulation && _vm.getWealthAccumulationData() !== [] && this.$data.views.wealthAccumulation === 'list') ? _c('table', {
    staticClass: "retirement__table list"
  }, [_c('tr', {
    staticClass: "retirement__table-row retirement__table-row--heading"
  }, [_c('th', {
    staticClass: "retirement__table-cell retirement__table-cell--age"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.age')))]), _vm._v(" "), _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.details')))])]), _vm._v(" "), _vm._l((_vm.getWealthAccumulationData()), function(item, index) {
    return _c('tr', {
      staticClass: "retirement__table-row"
    }, [_c('td', {
      staticClass: "retirement__table-cell retirement__table-cell--age"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'age'))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "retirement__table-cell"
    }, [(_vm.showColumn('wealthAccumulation', 'open')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.savings')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'open')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'rrsp')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.registered')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'rrsp')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'tfsa')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.tfsa')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'tfsa')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'lockedin')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.lockedin')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'lockedin')))
      }
    })]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (this.$data.blocks.wealthAccumulation && _vm.getWealthAccumulationData() !== [] && this.$data.views.wealthAccumulation === 'table') ? _c('table', {
    staticClass: "retirement__table tabular"
  }, [_c('tr', {
    staticClass: "retirement__table-row retirement__table-row--heading"
  }, [_c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.age')))]), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'open')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.savings')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'lockedin')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.lockedin')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'rrsp')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.registered')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'tfsa')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.tfsa')))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.getWealthAccumulationData()), function(item, index) {
    return _c('tr', {
      staticClass: "retirement__table-row"
    }, [_c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'age'))
      }
    }), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'open')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'open')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'lockedin')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'lockedin')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'rrsp')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'rrsp')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('wealthAccumulation', 'tfsa')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'tfsa')))
      }
    }) : _vm._e()])
  })], 2) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "retirement__block"
  }, [_c('div', {
    class: _vm.sectionClass('systematicWithdrawals')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('systematicWithdrawals')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('systematicWithdrawals')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.deaccumulation')))]), _vm._v(" "), (this.$data.blocks.systematicWithdrawals) ? _c('span', {
    staticClass: "section__buttons"
  }, [_c('button', {
    class: _vm.buttonClass('systematicWithdrawals', 'list'),
    on: {
      "click": function($event) {
        _vm.toggleView('systematicWithdrawals', 'list')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "view-list"
    }
  })], 1), _vm._v(" "), _c('button', {
    class: _vm.buttonClass('systematicWithdrawals', 'table'),
    on: {
      "click": function($event) {
        _vm.toggleView('systematicWithdrawals', 'table')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "view-table"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (this.$data.blocks.systematicWithdrawals && _vm.showSystematicWithdrawals()) ? _c('Chart', {
    attrs: {
      "type": "bar",
      "stacked": "true",
      "data": _vm.chartSystematicWithdrawals(),
      "id": "systematicWithdrawalsChart"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "report__disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.showDisclaimer())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "retirement__table-wrap"
  }, [(this.$data.blocks.systematicWithdrawals && _vm.getSystematicWidthdrawlsData() !== [] && this.$data.views.systematicWithdrawals === 'list') ? _c('table', {
    staticClass: "retirement__table list"
  }, [_c('tr', {
    staticClass: "retirement__table-row retirement__table-row--heading"
  }, [_c('th', {
    staticClass: "retirement__table-cell retirement__table-cell--age"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.age')))]), _vm._v(" "), _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.remainingWealth')))])]), _vm._v(" "), _vm._l((_vm.getSystematicWidthdrawlsData()), function(item, index) {
    return _c('tr', {
      staticClass: "retirement__table-row"
    }, [_c('td', {
      staticClass: "retirement__table-cell retirement__table-cell--age"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'age'))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "retirement__table-cell"
    }, [(_vm.showColumn('systematicWithdrawals', 'savings')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.savings')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'savings')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'rrsp')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.registered')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'rrsp')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'tfsa')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.tfsa')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'tfsa')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'lockedin')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.lockedin')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'lockedin')))
      }
    })]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (this.$data.blocks.systematicWithdrawals && _vm.getSystematicWidthdrawlsData() !== [] && this.$data.views.systematicWithdrawals === 'table') ? _c('table', {
    staticClass: "retirement__table tabular"
  }, [_c('tr', {
    staticClass: "retirement__table-row retirement__table-row--heading"
  }, [_c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.age')))]), _vm._v(" "), _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.year')))]), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'savings')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.savings')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'lockedin')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.lockedin')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'rrsp')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.registered')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'tfsa')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.tfsa')))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.getSystematicWidthdrawlsData()), function(item, index) {
    return _c('tr', {
      staticClass: "retirement__table-row"
    }, [_c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'age'))
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'year'))
      }
    }), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'savings')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'savings')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'lockedin')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'lockedin')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'rrsp')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'rrsp')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('systematicWithdrawals', 'tfsa')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'tfsa')))
      }
    }) : _vm._e()])
  })], 2) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "retirement__block"
  }, [_c('div', {
    class: _vm.sectionClass('postRetirementCashFlow')
  }, [_c('h3', {
    staticClass: "report__section-heading"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sectionSetChecked('postRetirementCashFlow')
    },
    on: {
      "change": function($event) {
        _vm.sectionToggle('postRetirementCashFlow')
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "report__section-label"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.postRetirementCashFlows')))]), _vm._v(" "), (this.$data.blocks.postRetirementCashFlow) ? _c('span', {
    staticClass: "section__buttons"
  }, [_c('button', {
    class: _vm.buttonClass('postRetirementCashFlow', 'list'),
    on: {
      "click": function($event) {
        _vm.toggleView('postRetirementCashFlow', 'list')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "view-list"
    }
  })], 1), _vm._v(" "), _c('button', {
    class: _vm.buttonClass('postRetirementCashFlow', 'table'),
    on: {
      "click": function($event) {
        _vm.toggleView('postRetirementCashFlow', 'table')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "icon": "view-table"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (this.$data.blocks.postRetirementCashFlow && _vm.showPostRetirementCashFlowData()) ? _c('Chart', {
    attrs: {
      "type": "bar",
      "stacked": "true",
      "data": _vm.chartPostRetirementCashFlowData(),
      "id": "postRetirementCashFlowChart"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "report__disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.showDisclaimer())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "retirement__table-wrap"
  }, [(this.$data.blocks.postRetirementCashFlow && _vm.getPostRetirementCashFlowData() !== [] && this.$data.views.postRetirementCashFlow === 'list') ? _c('table', {
    staticClass: "retirement__table list"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.getPostRetirementCashFlowData()), function(item, index) {
    return _c('tr', {
      staticClass: "retirement__table-row"
    }, [_c('td', {
      staticClass: "retirement__table-cell retirement__table-cell--age"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'age'))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "retirement__table-cell"
    }, [(_vm.showColumn('postRetirementCashFlow', 'savings')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.savings')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'savings')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'rrsp')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.registered')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'rrsp')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'tfsa')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.tfsa')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'tfsa')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'lockedin')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.lockedin')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'lockedin')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'cpp')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.cpp')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'cpp')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'oas')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.oas')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'oas')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'pension')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.pension')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'pension')))
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'other')) ? _c('div', {
      staticClass: "retirement__table-detail"
    }, [_c('span', {
      staticClass: "retirement__table-detail-label"
    }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.other')) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "retirement__table-detail-value",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'other')))
      }
    })]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (this.$data.blocks.postRetirementCashFlow && _vm.getPostRetirementCashFlowData() !== [] && this.$data.views.postRetirementCashFlow === 'table') ? _c('table', {
    staticClass: "retirement__table tabular"
  }, [_c('tr', {
    staticClass: "retirement__table-row retirement__table-row--heading"
  }, [_c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.age')))]), _vm._v(" "), _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.year')))]), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'available')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.income')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'savings')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.savings')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'rrsp')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.registered')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'tfsa')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.tfsa')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'lockedin')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.lockedin')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'cpp')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.cpp')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'oas')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.oas')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'pension')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.pension')))]) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'other')) ? _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v(_vm._s(_vm._translate('retirementPlanner.other')))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.getPostRetirementCashFlowData()), function(item, index) {
    return _c('tr', {
      staticClass: "retirement__table-row"
    }, [_c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'age'))
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.getTableItem(item, 'year'))
      }
    }), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'available')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'available')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'savings')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'savings')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'rrsp')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'rrsp')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'tfsa')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'tfsa')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'lockedin')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'lockedin')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'cpp')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'cpp')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'oas')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'oas')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'pension')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'pension')))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showColumn('postRetirementCashFlow', 'other')) ? _c('td', {
      staticClass: "retirement__table-cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(_vm.getTableItem(item, 'other')))
      }
    }) : _vm._e()])
  })], 2) : _vm._e()])], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "retirement__table-row retirement__table-row--heading"
  }, [_c('th', {
    staticClass: "retirement__table-cell retirement__table-cell--age"
  }, [_vm._v("Age")]), _vm._v(" "), _c('th', {
    staticClass: "retirement__table-cell"
  }, [_vm._v("Cash Flows")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e6e0677!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RetirementPlanner/RetirementPlanner.vue
// module id = 329
// module chunks = 0